import { render, staticRenderFns } from "./transaction-list-page.vue?vue&type=template&id=ee64e42e&"
import script from "./transaction-list-page.vue?vue&type=script&lang=js&"
export * from "./transaction-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl})
